export const FONT_SB_SANS_DISPLAY = 'SB Sans Display, sans-serif'
export const FONT_SB_SANS_INTERFACE = 'SB Sans Interface, sans-serif'

/** Pазмер шрифта, который используется в html и toRem
 */
export const BASE_FONT_SIZE = 14
